import { useQuery } from 'react-query';
import { getGTRBConfig, GetGTRBConfigResponse } from 'src/utils/Queries';

export function useGTRBConfig(fcName: string | undefined) {
    return useQuery<GetGTRBConfigResponse, Error>(
        ['gtrb-config', fcName],
        () => getGTRBConfig(fcName!)!,
        { enabled: !!fcName, staleTime: 300000 }
    );
}
